export const SetCurrentLanguage = "SET_CurrentLanguage";